import { apiFetch } from '../client';

export function inviteToProperty(ref, email, role) {
    return apiFetch('/map-api/property-share/invite/', {
        method: 'POST',
        body: JSON.stringify({ ref, email, role })
    })
}

export function listShares(ref) {
    return apiFetch('/map-api/property-share/list/', {
        method: 'POST',
        body: JSON.stringify({ ref })
    })
}

export function updateShareRole(shareId, role) {
    return apiFetch('/map-api/property-share/update-role/', {
        method: 'POST',
        body: JSON.stringify({ share_id: shareId, role })
    })
}

export function revokeShare(shareId) {
    return apiFetch('/map-api/property-share/revoke/', {
        method: 'POST',
        body: JSON.stringify({ share_id: shareId })
    })
}
